import React, { useContext } from 'react';
import { VIEW_MODE } from '../../utils/helpers';

interface UIContextShape {
  viewMode: VIEW_MODE;
  toggleViewMode: (viewMode: VIEW_MODE) => void;
  isEditButtonHidden: boolean;
  isInfoShown: boolean;
  setIsInfoShown: (isInfoShown: boolean) => void;
}

const defaultContextValue: UIContextShape = {
  viewMode: VIEW_MODE.DESKTOP,
  toggleViewMode: () => {},
  isEditButtonHidden: false,
  isInfoShown: false,
  setIsInfoShown: () => {},
};

const UIContext = React.createContext<UIContextShape>(defaultContextValue);
UIContext.displayName = 'UIContext';

const useUIContext = () => useContext(UIContext);

export { UIContext, UIContextShape, useUIContext };
